<app-kontable
        id="dt_certification"
        title = "{{ 'certificationList.sectionTitle' | translate }}"
        [columns] = "['id', 'code', 'description']"
        [titles] = "['common.id', 'common.code', 'common.description']"
        [showInfoButton]="false"
        [showRecoverButton]="false"
        [showGlobalFilter]="false"
        [showDetailsButton]="false"
        [showAddButton]="true"
        [(fireNewDataAvailable)]="newDataAvailable"
        [source]="srvCertification.certifications"
        (onAdd)="showAddOrEditDialog($event)"
        (onEdit)="showAddOrEditDialog($event)"
        (onRemove)="delete($event)">

</app-kontable>

<p-dialog
        *ngIf="showDialog"
        header="{{modalTitle}}"
        [width]="600"
        [(visible)]="showDialog"
        [responsive]="true"
        showEffect="fade"
        [modal]="true"
        (onHide)="onDialogHide()">
    <app-certification-form
            [dialogBoxCertification]="srvCertification.certificationEditing"
            (certificationAdded)="certificationAdded($event)"
            (certificationUpdated)="certificationUpdated($event)">
    </app-certification-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/certification/certification.component.html